import { combineReducers } from "redux";
import commonReducer from "./reducer/reducer";
import authReducer from "./authReducer";
import calendarReducer from "./calendarReducer";

const rootReducer = combineReducers({
  commonReducer,
  auth: authReducer,
  calendar: calendarReducer,
});

export default rootReducer;
